// MainPage.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';
import UserModal from '../components/UserModal';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';
import { Link } from 'react-router-dom';

import {
  get_users,
  create_user,
  update_user,
  delete_user,
} from '../api/api';


const ProtectionPage = () => {

  const { item_id } = useParams();
  const [ page, setPage] = useState(1);
  const [ userdata, setUserdata] = useState(1);
  const [ users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const modalRef = useRef();
  const updateModalRef = useRef();

  const newRowTemplate_user = {}; //TODO

  const role = localStorage.getItem('role');
  const canAdd = role === 'Admin';
  const onAdd = ()=>{
    openAndResetModal();
  }

  const onEdit = ()=>{
    openAndResetUpdateModal();
  }



  const updateGrid = async () => {

      const get_the_users = async () => {
          const res = await get_users();
          const data = res && res.data && res.data.results ? res.data.results : [];
          // HERE: this works just fine
          setUsers(data);     // Set state with resolved data
      };

      await get_the_users();
  }

  useEffect(() => {
      updateGrid();
  }, []);


  const openAndResetModal = () => {
    setModalOpen(true);
    setTimeout(() => {
      modalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };

  const openAndResetUpdateModal = () => {
    setUpdateModalOpen(true);
    setTimeout(() => {
      updateModalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };


  const retrieveData = async () => {
    try{
        const get_the_users = async () => {
            const res = await get_users();
            const data = res && res.data && res.data.results ? res.data.results : [];
            setUsers(data);     // Set state with resolved data
        };
        await get_the_users();
      }
      catch(error){
            console.error(error);
      }
      finally {
            setLoading(false); // Set loading to false after the fetch is complete
      }
  }


  const getColumDefs = (startEditing, stopEditing, setRecordToDelete, goToDetail) => {
    return [
      { field: "first_name",
        headerName: "Nome",
      },
      { field: "last_name",
        headerName: "Cognome",
        flex: 1
      },
      { field: "role",
        headerName: "Ruolo",
      }
    ];
  };



  const editCallback = async (val) => {

      const res = await get_users();
      if(res && res.data){
        const the_users = res.data.results.filter((a)=>(a.id==val));
        if(the_users && (the_users.length)>0){
          const the_user = the_users[0];
          setUserdata(the_user);
          setUpdateModalOpen(true);
          setTimeout(() => {
            updateModalRef.current?.setup(the_user); // ensure reset happens *after* modal is mounted
          }, 0);
        }
      }
  };






  const setThePage = (page_id)=>{
    setPage(page_id);
  }

  return (
    <div>
      <TopBar />

      <div className="content">


        <div className="main-content">


          <div className="dynamic-table-topbar-right">
            <TitleBackButton
              title={"Pannello Admin"}
            />
            <div>
              { canAdd && (
              <button className="dynamic-table-add-new" onClick={()=>{onAdd()}}>
                Aggiungi
              </button>
              )}
            </div>

          </div>

          <div className="dynamic-table-outer">

                <DynamicTable
                  items={users}
                  getColumnDefs={getColumDefs}
                  deleteFunction={delete_user}
                  showDownloadButtons={false}
                  editCallback={editCallback}
                  updateGrid={updateGrid}

                />
                <UserModal ref={modalRef}  isOpen={isModalOpen}  onClose={()=>{updateGrid(); setModalOpen(false)}}/>
                <UserModal userdata={userdata} ref={updateModalRef} isOpen={isUpdateModalOpen}  onClose={()=>{updateGrid(); setUpdateModalOpen(false)}}/>


            </div>

        </div>

      </div>
    </div>
  );
};

export default ProtectionPage;
